import PropTypes from "prop-types";

export default function Logo({
  showText = false,
  text = "Fortify",
  logoClassName = "h-8 w-8",
  textClassName = "text-lg font-bold tracking-wide",
  className = "",
}) {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <img src="/images/fortify_logo_black.svg" alt={showText ? text : "Fortify logo"} className={logoClassName} />
      {showText ? <span className={textClassName}>{text}</span> : null}
    </div>
  );
}

Logo.propTypes = {
  showText: PropTypes.bool,
  text: PropTypes.string,
  logoClassName: PropTypes.string,
  textClassName: PropTypes.string,
  className: PropTypes.string,
};
